/* istanbul ignore file */

import reverseObject from './reverseObject';

export default reverseObject;
